import { Component } from "preact";
import Widget from "./base.js";
import $ from "jquery";
import spacetime from "spacetime";
import { AdSlot } from "./ad-slot";
import RawMarkup from "tpm-js/raw-markup";
import getParameterByName from "tpm-js/get-parameter-by-name";

/**
 * the ajax-driven live blog entries stream
 * props: parent
 */
export class LiveBlogEntries extends Widget {
	componentWillMount() {
		this.state.order = "desc";
		this.postsPerReq = 10;
	}

	componentDidMount() {
		window.tpm_LiveBlogEntries = this;
		this.getAuthors();

		//if we have a entry param in the querystring, link directly to that entry
		const queriedID = parseInt(this.queriedID);
		if (queriedID) {
			this.allEntries = []; //we dont want this in state
			this.getEntriesAtID(queriedID);
		}
		//else do things normally
		else this.getEntries();

		//request entries every 5 mins
		const self = this;
		setInterval(function () {
			if (self.state.order === "asc") return;
			self.getEntries();
		}, 300000);
	}

	componentDidUpdate() {
		//this scrolls the queried entry into view
		if (!this.hasData) return;
		if (this.scrolledOnce) return;
		if (this.queriedID) {
			let scrollDistance =
				window.pageYOffset +
				document.querySelector(".LiveBlogEntries").getBoundingClientRect().top -
				60; //minus 60px for header

			if (window.is_desktop) {
				//hack to correct scroll distance when an AP widget is embedded in the page
				//detecting the script tag since its easier to find than the iframe
				const apScript = document.querySelector(
					'.js_article-content script[src="https://elections.ap.org/widgets/js/resizer.client.min.js"]'
				);
				//get the height of the iframe next to the script tag
				//if the iframe height is over 500, we can assume it's loaded & resized. scrollDistance will be accurate.
				//otherwise, we assume it has yet to load and assume a default height of 450px
				if (apScript && apScript.nextElementSibling.offsetHeight < 500) {
					scrollDistance += 450;
				}
			}

			window.scroll({
				top: scrollDistance,
				left: 0,
				behavior: "smooth",
			});
			this.scrolledOnce = true;
		}
	}

	toggleSelect() {
		this.setState({
			selecting: !this.state.selecting,
		});
	}

	reorder(order = "desc") {
		if (this.state.order === order) {
			this.setState({
				selecting: !this.state.selecting,
			});

			return;
		}

		this.setState(
			{
				order: order,
				posts: null,
				selecting: false,
			},
			() => {
				this.getEntries();
			}
		);
	}

	get queriedID() {
		return getParameterByName("entry");
	}

	getAuthors() {
		const self = this;
		jQuery
			.ajax({
				method: "GET",
				url: `https://${document.location.hostname}/wp-json/tpm-liveblog/v1/authors`,
				dataType: "json",
				xhrFields: {
					withCredentials: false,
				},
				crossDomain: true,
			})
			.done(function (response) {
				let authors = {};

				response.forEach((author) => {
					authors[author.ID] = author.display_name;
				});

				self.setState({
					authors: authors,
				});
			})
			.fail(function (xhr, status) {
				console.log("wp json api request failed to get authors");
				console.log(status);
				self.setState({
					ajaxError: true,
					loadingMore: false,
					newPosts: false,
				});
			});
	}

	getEntries(offset = 0, fromLoadMoreBtn = false) {
		const self = this;
		const postsPerReq = this.postsPerReq;
		jQuery
			.ajax({
				method: "GET",
				url: `https://${document.location.hostname}/wp-json/wp/v2/live-blog-update?per_page=${postsPerReq}&order=${this.state.order}&offset=${offset}&parent=${this.props.parent}`,
				dataType: "json",
				xhrFields: {
					withCredentials: false,
				},
				crossDomain: true,
			})
			.done(function (response) {
				//first request
				if (!self.state.posts) {
					self.setState({
						posts: response,
						loadingMore: false,
						newPosts: false,
					});
				}

				// if fromLoadMoreBtn is true (in the call from the load more btn), we can skip the dedupe
				// and just spread the new responses in after the existing posts.
				else if (fromLoadMoreBtn) {
					console.log(response.length);
					console.log(postsPerReq);
					self.setState({
						posts: [...self.state.posts, ...response],
						loadingMore: false,
						noMore: response.length < postsPerReq,
						newPosts: false,
					});
					//default behavior, dedupe & set the newPosts state
				} else {
					let newPosts = response;

					//if there are un-rendered newPosts, we dont want to lose those.
					//dedupe the arrays and set that to state
					if (self.state.newPosts)
						newPosts = self.dedupePosts(newPosts, self.state.newPosts);

					//we also dont want any posts already rendered showing up in the new posts count, so dedupe again
					if (self.state.newPosts)
						newPosts = self.dedupePosts(newPosts, self.state.posts);

					self.setState({
						newPosts: newPosts,
					});
				}
			})
			.fail(function (xhr, status) {
				console.log("wp json api request failed to get posts");
				console.log(status);
				self.setState({
					ajaxError: true,
					loadingMore: false,
					newPosts: false,
				});
			});
	}

	getEntriesAtID(ID) {
		let entryIndex = null;
		const self = this;

		function findEntryIndex(page) {
			let index = null;
			page.forEach((entry, i) => {
				if (entry.id === ID) index = i;
			});
			return index;
		}

		function getAllPages(page = 1) {
			jQuery
				.ajax({
					method: "GET",
					url: `https://${document.location.hostname}/wp-json/wp/v2/live-blog-update?per_page=100&page=${page}&parent=${self.props.parent}`,
					dataType: "json",
					xhrFields: {
						withCredentials: false,
					},
					crossDomain: true,
				})
				.done(function (response) {
					self.allEntries = [...self.allEntries, ...response];

					entryIndex = findEntryIndex(self.allEntries);

					if (entryIndex) {
						//found it! lets write posts to state
						self.setState({
							posts: self.allEntries.slice(entryIndex, entryIndex + 10),
							//we need to keep the queried entry in newPosts so that countNewPosts works
							newPosts: self.allEntries.slice(0, entryIndex + 1),
							loadingMore: false,
						});
					}

					//last page of entries and no post found. just render the first 10
					else if (response.length < 100) {
						self.setState({
							posts: self.allEntries.slice(0, 10),
							newPosts: false,
							loadingMore: false,
						});
					}

					//try another page
					else {
						page = page + 1;
						getAllPages(page);
					}
				})
				.fail(function (xhr, status) {
					console.log(
						"wp json api request failed, function getAllPages. This probalby means the queried entry isnt part of this live blog"
					);
					console.log(status);
					self.setState({
						posts: self.allEntries.slice(0, 10),
						newPosts: false,
						loadingMore: false,
					});
				});
		}

		let page = 1;
		getAllPages(page);
	}

	get hasNewPosts() {
		const { posts, newPosts } = this.state;
		if (!posts || !newPosts) return false;
		return posts[0].id !== newPosts[0].id;
	}

	get countNewPosts() {
		if (!this.hasNewPosts) return 0;

		const { posts, newPosts } = this.state;
		const findID = posts[0].id;
		let idx = 0;
		// we need
		for (let i = 0; i < newPosts.length; i++) {
			if (newPosts[i].id === findID) {
				idx = i;
				break;
			}
		}
		return idx;
	}

	dedupePosts(newPosts, oldPosts) {
		// dedupe
		//
		// could do this with an array instead of a set if this doesn't transpile for IE/etc
		const seen = new Set();
		const uniqPosts = [...newPosts, ...oldPosts].filter((post) => {
			const duplicate = seen.has(post.id);
			seen.add(post.id);
			return !duplicate;
		});
		return uniqPosts;
	}

	mergePosts() {
		const { posts, newPosts } = this.state;
		const uniqPosts = this.dedupePosts(newPosts, posts);
		this.setState(
			{
				posts: uniqPosts,
				newPosts: false,
			},
			this.scrollToTop()
		);
	}

	scrollToTop() {
		document.querySelector(".LiveBlogEntries").scrollIntoView();
		window.scrollBy(0, -65);
	}

	get hasData() {
		return this.state.posts && this.state.authors;
	}

	renderNewButton() {
		if (!this.hasNewPosts) return;

		const { posts, newPosts } = this.state;
		const count = this.countNewPosts;
		return (
			<div class="LiveBlogEntries__Sticky">
				<div
					class="LiveBlogEntries__Button"
					onClick={this.mergePosts.bind(this)}
				>
					{count} New Post{count === 1 ? "" : "s"}
				</div>
			</div>
		);
	}

	renderMoreButton() {
		if (this.state.noMore) return;
		if (this.state.loadingMore) return this.renderLoading();
		//if there are fewer than 30 posts the blog has just started, no need to render this button
		if (this.state.posts.length < this.postsPerReq) return;

		return (
			<div class="LiveBlogEntries__LoadMore">
				<div
					class="Button --white-to-red"
					onClick={() => {
						const offset = this.countNewPosts + this.state.posts.length;
						this.setState({ loadingMore: true }, this.getEntries(offset, true));
					}}
				>
					Load More
				</div>
			</div>
		);
	}

	renderLoading() {
		return (
			<div class="LiveBlogEntries__LoadMore">
				<div class="LiveBlogEntries__LoadingMore">
					<i class="far fa-spinner-third fa-spin fa-3x"></i>
				</div>
			</div>
		);
	}

	renderEntries() {
		let entries = this.state.posts.map((post) => {
			return (
				<Entry
					post={post}
					authors={this.state.authors}
					showHeadline={this.props.headlines}
				/>
			);
		});

		if (!window.is_adfree) {
			const LBAdSlot = (unit) => {
				return (
					<div class="LiveBlogEntries__AdSlot">
						<AdSlot
							id={unit}
							unit={unit}
							sizes={[[300, 250]]}
							noRefresh={false}
							eager={true}
						/>
					</div>
				);
			};

			// if (window.is_basic || window.is_logged_out) {
			if (true) {
				console.log("LiveBlogEntries: inserting ad slots");
				if (entries.length >= 9)
					entries.splice(9, 0, LBAdSlot("TPM_preContent"));
				if (entries.length >= 6)
					entries.splice(6, 0, LBAdSlot("TPM_preContent"));
				if (entries.length >= 3)
					entries.splice(3, 0, LBAdSlot("TPM_preContent"));
			}
		}

		return entries;
	}

	renderOrderControls() {
		const options = (
			<div
				class={`LiveBlogEntries__OrderOptions ${
					this.state.selecting ? "--active" : ""
				}`}
			>
				<div
					class={`LiveBlogEntries__OrderOption ${
						this.state.order === "desc" ? "--selected" : ""
					}`}
					onclick={() => {
						this.reorder("desc");
					}}
				>
					Latest
				</div>
				<div
					class={`LiveBlogEntries__OrderOption ${
						this.state.order === "asc" ? "--selected" : ""
					}`}
					onclick={() => {
						this.reorder("asc");
					}}
				>
					Oldest
				</div>
			</div>
		);

		return (
			<div class="LiveBlogEntries__OrderControls">
				<div
					class="LiveBlogEntries__OrderSelect"
					onClick={this.toggleSelect.bind(this)}
				>
					{this.state.order === "desc" ? "Latest" : "Oldest"}{" "}
					{this.state.selecting ? (
						<i class="fa-solid fa-chevron-up"></i>
					) : (
						<i class="fa-solid fa-chevron-down"></i>
					)}
				</div>
				{options}
			</div>
		);
	}

	renderContent() {
		if (!this.hasData) return;

		return [
			this.renderOrderControls(),
			<div class="LiveBlogEntries__EntriesWrapper">
				{this.renderNewButton()}
				{this.renderEntries()}
			</div>,
			this.renderMoreButton(),
		];
	}
}

class Entry extends Component {
	get entryLink() {
		return `https://${document.location.hostname}${window.location.pathname}?entry=${this.props.post.id}`;
	}

	updateClipboard() {
		const self = this;
		navigator.clipboard.writeText(self.entryLink).then(
			function () {
				/* clipboard successfully set */
				self.setState({ copied: true });
				setTimeout(() => {
					$(`#ToolTip-${self.props.post.id}`).addClass("--fade-out");
				}, 3000);

				setTimeout(() => {
					self.setState({ copied: false });
				}, 3750);
			},
			function () {
				/* clipboard write failed */
			}
		);
	}

	renderCopyableLink() {
		if (!navigator.clipboard) return;
		return (
			<span
				class="LiveBlogEntries__EntryShareLink"
				onClick={this.updateClipboard.bind(this)}
			>
				<i class="fa-regular fa-link"></i>
				{this.state.copied ? (
					<span
						class="LiveBlogEntries__EntryShareLinkToolTip"
						id={`ToolTip-${this.props.post.id}`}
					>
						Link Copied
					</span>
				) : (
					""
				)}
			</span>
		);
	}

	render({ post, authors }) {
		const d = spacetime(post.date, "America/New_York");
		let time = d.time();
		time = time.replace("pm", " P.M.");
		time = time.replace("am", " A.M.");

		//if the entry's timestamp is over 24 ours old, lets show the full publication date
		let date = null;
		let now = spacetime.now("America/New_York");
		const oneDayAgo = now.subtract(1, "day");
		const oneHourAgo = now.subtract(1, "hour");
		if (d.isBefore(oneDayAgo)) {
			date = `${d.format("numeric-us")} | ${time}`.replaceAll("/", ".");
		} else if (d.isBefore(oneHourAgo)) {
			//show xH ago
			const hoursAgo = Math.abs(now.diff(d, "hour"));
			date = <span style="color:#990000;font-weight:bold;">{hoursAgo}h</span>;
		} else {
			//show xM ag
			const minutesAgo = Math.abs(now.diff(d, "minute"));
			date = <span style="color:#990000;font-weight:bold;">{minutesAgo}m</span>;
		}

		//if parent page has the entry-headlines option selected, show the entry headline
		let postHeadline = null;
		if (this.props.showHeadline === "1")
			postHeadline = (
				<h2 style={{ "margin-bottom": "0.5em" }}>
					<RawMarkup content={post.title.rendered} class={""} />
				</h2>
			);

		return (
			<section class="LiveBlogEntries__Entry" id={`EntryID_${post.id}`}>
				<div class="AuthorAndDate --sans-serif">
					<div class="AuthorAndDate__Date">{date}</div>
				</div>
				<div className="LiveBlogEntries__EntryHeadline">{postHeadline}</div>
				<RawMarkup
					content={post.content.rendered}
					class={"LiveBlogEntries__EntryText"}
				/>
				<div className="LiveBlogEntries__EntryFooter">
					<div className="LiveBlogEntries__EntryByline">
						- {authors[post.author]}
					</div>
					{this.renderCopyableLink()}
				</div>
			</section>
		);
	}
}
